import { useQuery } from '@tanstack/react-query';

import { GroupBrief, GroupID } from '@playq/octopus2-admin';
import { GenericFailure } from '@playq/services-shared';

import { createRequestQueue, unwrapEither, IUseQueryOptionsExtended } from '/api/service-hooks';
import { services2 } from '/api/services2';

import { groupServiceBriefTags } from './constants';

const queue = createRequestQueue<GroupID, GroupBrief>(
  (groupIDs) => unwrapEither(services2.adminGroupsService.briefFor(groupIDs)),
  {
    predicate: (groupID, groupBrief) => groupID?.serialize() === groupBrief?.id.serialize(),
  }
);

export const useGroupBriefGet = (
  id: GroupID,
  options?: IUseQueryOptionsExtended<GroupBrief | null, GenericFailure | Error>
) =>
  useQuery<GroupBrief | null, GenericFailure | Error>({
    queryKey: [...groupServiceBriefTags, id?.serialize()],
    queryFn: () => queue.push(id),
    staleTime: Infinity,
    ...options,
  });
